
<div class="bc-email-outgoing-header" *ngIf="model">

  <div class="bc-email-outgoing-header-form" [attr.data-automation-id]="'gc-email-outgoing-header-form'">
    <h3 class="bc-panel-title">{{ 'genesysEmailOutgoingHeader.panelTitle' | translate }}</h3>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'genesysEmailOutgoingHeader.fromLabel' | translate }}</label>
      <input class="bc-input" type="text" [value]="from" [disabled]="true" />
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <div class="bc-label-row clearfix bc-form-required">
        <label class="bc-label bc-truncate">{{ 'genesysEmailOutgoingHeader.toLabel' | translate }}</label>
        <span class="bc-label bc-label-required">{{ 'genesysEmailOutgoingHeader.requiredLabel' | translate }}</span>
      </div>
      <input class="bc-input" type="text" [ngModel]="to"
             (ngModelChange)="validateEmailAndEmitModel($event, emailAddressTypes.TO)"
             [ngClass]="{'bc-validation-error-input': !isValid(emailAddressTypes.TO) || isToEmpty()}"
             data-automation-id="gc-outgoing-header-to-input" />
      <span class='bc-span bc-validation-error-text js-error-email-to'
            *ngIf="!isValid(emailAddressTypes.TO) || isToEmpty()"
            [innerText]="'genesysEmailOutgoingHeader.invalidToEmailMessage' | translate: { invalidToEmailMessage: addressStates.to.InvalidAddresses }"
            data-automation-id="gc-outgoing-header-to-error"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'genesysEmailOutgoingHeader.ccLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             [ngModel]="cc"
             (ngModelChange)="validateEmailAndEmitModel($event, emailAddressTypes.CC)"
             [ngClass]="{'bc-validation-error-input': !isValid(emailAddressTypes.CC)}"
             [attr.data-automation-id]="'gc-outgoing-header-cc-input'"/>
      <span class='bc-span bc-validation-error-text js-error-email-cc'
            *ngIf="!isValid(emailAddressTypes.CC)"
            [innerText]="'genesysEmailOutgoingHeader.invalidCcEmailMessage' | translate: { invalidCcEmailMessage: addressStates.cc.InvalidAddresses }"
            [attr.data-automation-id]="'gc-outgoing-header-cc-error'"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'genesysEmailOutgoingHeader.bccLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             [ngModel]="bcc"
             (ngModelChange)="validateEmailAndEmitModel($event, emailAddressTypes.BCC)"
             [ngClass]="{'bc-validation-error-input': !isValid(emailAddressTypes.BCC)}"
             [attr.data-automation-id]="'gc-outgoing-header-bcc-input'"/>
      <span class='bc-span bc-validation-error-text js-error-email-bcc'
            *ngIf="!isValid(emailAddressTypes.BCC)"
            [innerText]="'genesysEmailOutgoingHeader.invalidBccEmailMessage' | translate: { invalidBccEmailMessage: addressStates.bcc.InvalidAddresses }"
            [attr.data-automation-id]="'gc-outgoing-header-bcc-error'"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'genesysEmailOutgoingHeader.subjectLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             (ngModelChange)="headerChange({ subject: $event })"
             [(ngModel)]="model.subject"
             [attr.data-automation-id]="'gc-outgoing-header-subject-input'"/>
    </div>
  </div>

  <div class="bc-actions clearfix" *ngIf="displayActions">
    <button (click)="savePressed()"
            class="btn btn-dark js-save-header-button"
            [disabled]="!isHeaderStateValid()"
            [attr.data-automation-id]="'gc-outgoing-header-save-button'">
      <span>{{ 'genesysEmailOutgoingHeader.saveButtonText' | translate }}</span>
    </button>

    <button (click)="cancelPressed()"
            class="btn btn-light js-cancel-header-button"
            [attr.data-automation-id]="'gc-outgoing-header-cancel-button'">
      <span>{{ 'genesysEmailOutgoingHeader.cancelButtonText' | translate }}</span>
    </button>
  </div>
</div>
